import { render, staticRenderFns } from "./AcessarPedidoItensListagem.vue?vue&type=template&id=31f6443a&scoped=true"
import script from "./AcessarPedidoItensListagem.vue?vue&type=script&lang=js"
export * from "./AcessarPedidoItensListagem.vue?vue&type=script&lang=js"
import style0 from "./AcessarPedidoItensListagem.vue?vue&type=style&index=0&id=31f6443a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f6443a",
  null
  
)

export default component.exports